module.exports = __webpack_public_path__ + "static/media/icon_scoreboard.6024e3c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_scoreboard.svg
// module id = 171
// module chunks = 0